import http from '@/services/Http/http'
import auth from '@/services/Auth'
import apiService from '@/services/ApiService'
import store from '@/store/store'
import { BusinessException, TechnicalException } from '@/services/ErrorHandler'

export default {
  async fetchCoversbyStatusPerPage (pagenumber, pagesize, status, filter, from, to, sortBy, sortingOrder, companyId, coverId) {
    pagenumber = pagenumber - 1
    let requestparams = new URLSearchParams()
    requestparams.append('page', pagenumber)
    requestparams.append('pageSize', pagesize)
    if (status) {
      requestparams.append('status', status)
    }

    requestparams.append('filter', filter)
    if (from) {
      requestparams.append('from', from)
    }
    if (to) {
      requestparams.append('to', to)
    }
    if (companyId && companyId.length > 0) {
      requestparams.append('buyerId', companyId)
    }
    requestparams.append('sortBy', sortBy)
    requestparams.append('sortingOrder', sortingOrder)

    if (!!coverId && coverId.length > 0) {
      requestparams.append('coverId', coverId)
    }

    requestparams.append('version', '3')

    let response = await apiService.getCoverageClaimApiService().get('coverage/invoices', { params: Object.fromEntries(requestparams) })
    if (response.status === 200) {
      return {
        items: response.data,
        totalCount: Number(response.headers['x-totalcount'])
      }
    }

    return {
      items: [],
      totalCount: 0
    }
  },
  async fetchCompaniesId (companiesId) {
    try {
      let requestparams = new URLSearchParams()
      requestparams.append('ids', companiesId.join(','))
      requestparams.append('version', '2')

      let response = await apiService.getCoverageClaimApiService().get('transactors', { params: Object.fromEntries(requestparams) })
      if (response.status === 200) {
        let companies = response.data.map((item) => {
          let principalIdentifier = item.ExternalIds.find(function (transactor) {
            return transactor.IsPrincipal === true
          })
          let ehIdentifier = item.ExternalIds.find(function (transactor) {
            return transactor.ExternalService === 'eulerid'
          })
          return {
            id: item.Id,
            name: item.Name,
            ehId: ehIdentifier != null ? ehIdentifier.ExternalId : '',
            address: {
              country: store.getters['countries/getCountry'](item.Address.CountryCode).CountryName,
              city: item.Address.City,
              streetNumber: item.Address.StreetNumber,
              streetName: item.Address.StreetName,
              postCode: item.Address.PostCode
            },
            externalIds: item.ExternalIds.map((external) => {
              return {
                service: external.ExternalId,
                id: external.ExternalService
              }
            }),
            identifierType: principalIdentifier != null ? principalIdentifier.ExternalService : '',
            identifierValue: principalIdentifier != null ? principalIdentifier.ExternalId : ''
          }
        })
        return {
          items: companies
        }
      }
      return {
        items: []
      }
    } catch (err) {
      console.log(err)
      return {
        items: []
      }
    }
  },
  async fetchMappedCompaniesFromId (companiesId) {
    let resultcompanies = await this.fetchCompaniesId(companiesId)
    return resultcompanies.items.map((item) => {
      return {
        id: item.id,
        name: item.name,
        ehId: item.ehId,
        identifierType: item.identifierType,
        identifierValue: item.identifierValue
      }
    })
  },
  async fetchAllCountries () {
    try {
      let params = {
        version: '2'
      }
      if (auth.hasCoverageAccess() || auth.hasClaimAccess()) {
        let response = await apiService.getCoverageClaimApiService().get('lookups/countries', { params })
        return response.data
      }
      return []
    } catch (err) {
      console.log(err)
      return []
    }
  },
  async getPrincipalIdentifierForCountry (country) {
    try {
      let params = {
        version: '2'
      }
      if (auth.hasCoverageAccess() || auth.hasClaimAccess()) {
        let response = await apiService.getCoverageClaimApiService().get(`lookups/services/${country}`, { params })
        return response.data.find(function (identifier) {
          return identifier.IsPrincipal === true
        })
      }
      return null
    } catch (err) {
      console.log(err)
      return null
    }
  },
  async createsubmitClaim (formadata, coverid) {
    try {
      let params = {
        version: '2'
      }
      let response = await http.Claim.post(`coverage/${coverid}/claim`, formadata, {
        headers: { 'Content-Type': 'multipart/form-data' },
        params
      })
      return response.status === 200
    } catch (err) {
      console.log(err)
      return false
    }
  },
  async getClaimContactInfo (companyId) {
    try {
      let params = {
        version: '3'
      }
      let response = await http.Claim.get(`coverage/invoices/claims/contactInformation/${companyId}`, { params })
      return response.status === 200 ? response.data : null
    } catch (err) {
      console.log(err)
      return null
    }
  },
  async getCoverDetails (coverid) {
    try {
      let params = {
        version: '2'
      }
      let response = await apiService.getCoverageClaimApiService().get(`coverage/${coverid}`, { params })
      return response.status === 200 ? response.data : null
    } catch (err) {
      console.log(err)
      return null
    }
  },
  async getCustomerInvoiceCoverCount () {
    try {
      let params = {
        version: '3'
      }
      let response = await apiService.getCoverageClaimApiService().get('coverage/invoices/count', { params })
      return response.status === 200 ? response.data : undefined
    } catch (error) {
      console.log(error)
      return undefined
    }
  },
  async searchCompaniesByIdentifier (country, identifierType, identifierValue) {
    try {
      let params = {
        countryCode: country,
        service: identifierType,
        id: identifierValue,
        version: '2'
      }
      let response = await apiService.getServiceForCompaniesV3().get(`transactors`, { params })
      return response.status === 200 ? response.data : null
    } catch (error) {
      console.log(error)
      return null
    }
  },
  async searchCompaniesByName (country, companyName, stateCode, city, postCode, phone) {
    if (!country || !companyName) {
      return null
    }
    try {
      let params = {
        countryCode: country,
        name: companyName,
        stateCode: stateCode || '',
        postCode: postCode || '',
        city: city || '',
        phoneNumber: phone || '',
        version: '2'
      }
      http.removeEmptyKeys(params)

      let response = await apiService.getServiceForCompaniesV3().get(`transactors`, { params })
      return response.status === 200 ? response.data : null
    } catch (error) {
      console.log(error)
      return null
    }
  },
  async createCover (coverOptions) {
    try {
      let params = {
        version: '2'
      }
      let formdata = {
        sellerId: coverOptions.sellerId,
        buyerId: coverOptions.buyerId,
        invoice: {
          amount: coverOptions.invoiceValue,
          currency: coverOptions.currency,
          dueAt: coverOptions.dueDate,
          issuedAt: coverOptions.issueDate,
          number: coverOptions.invoiceNumber
        }
      }
      let response = await http.Coverage.post(`coverage`, formdata, { params })
      return response.status === 200 ? response.data : null
    } catch (error) {
      console.log(error)
      return null
    }
  },
  async updateCover (coverOptions) {
    try {
      let params = {
        version: '3'
      }
      let formdata = {
        invoice: {
          amount: coverOptions.invoice.invoiceValue,
          dueAt: coverOptions.invoice.dueDate,
          issuedAt: coverOptions.invoice.issueDate,
          number: coverOptions.invoice.invoiceNumber
        }
      }
      let response = await http.Coverage.patch(`coverage/invoices/${coverOptions.id}`, formdata, { params })
      return response.status === 200 ? response.data : null
    } catch (error) {
      if (error.response.status === 401 || error.response.status === 403) {
        throw new BusinessException('1313', 'Failed to update the quote')
      } else if (error.response.status === 422) {
        throw error
      } else if (error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.hasOwnProperty('code')) {
        throw new BusinessException(error.response.data.code, error.response.data.message)
      } else {
        throw new TechnicalException(error)
      }
    }
  },
  async activateCover (coverId) {
    try {
      let params = {
        version: '2'
      }
      let response = await http.Coverage.put(`coverage/${coverId}/activate`, {}, { params })
      if (response.data && response.data.hasOwnProperty('Code')) {
        throw new BusinessException(response.data.Code, response.data.Message)
      }
    } catch (error) {
      if (error instanceof BusinessException) {
        throw error
      } else if (error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.hasOwnProperty('code')) {
        throw new BusinessException(error.response.data.code, error.response.data.message)
      } else {
        throw new TechnicalException(error)
      }
    }
  },
  async rejectCover (coverId) {
    try {
      let params = {
        version: '2'
      }
      await http.Coverage.put(`coverage/${coverId}/reject`, {}, { params })
    } catch (error) {
      if (error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.hasOwnProperty('code')) {
        throw new BusinessException(error.response.data.code, error.response.data.message)
      } else {
        throw new TechnicalException(error)
      }
    }
  },
  async settleCover (coverId, settledAt) {
    try {
      let params = {
        version: '2'
      }
      let formdata = {
        SettledAt: settledAt
      }
      let response = await http.Coverage.put(`coverage/${coverId}/settle`, formdata, { params })
      return response.status === 200
    } catch (error) {
      console.log(error)
      return false
    }
  },
  async getClaimDocument (claimId, documentId) {
    try {
      let params = {
        version: '2'
      }
      let response = await http.Claim.get(`coverage/${claimId}/claim/documents/${documentId}`, { params })
      return response.data.url
    } catch (error) {
      throw new TechnicalException(error)
    }
  },
  async getClaimableBuyers () {
    try {
      let params = {
        version: '3'
      }
      let response = await http.Claim.get(`coverage/invoices/claimableBuyers`, { params })
      return response.data
    } catch (error) {
      console.log(error)
      return false
    }
  },
  async getClaimableInvoices (buyerId, businessUnitCode, policyId, extensionId) {
    let params = {
      version: '3',
      buyerId: buyerId,
      businessUnitCode: businessUnitCode,
      policyId: policyId,
      page: 0,
      pageSize: 100,
      status: 'Activated',
      sortBy: 'quotedAt',
      sortingOrder: 'desc'
    }
    if (!!extensionId && extensionId.length > 0) {
      params.extensionId = extensionId
    }

    try {
      let response = await http.Coverage.get(`coverage/invoices`, { params })
      let result = []
      if (!!response.data) {
        result = response.data.map(c => {
          return {
            coverId: c.id,
            invoiceNumber: c.invoice.number,
            invoiceDueDate: c.invoice.dueAt,
            invoiceIssueDate: c.invoice.issuedAt,
            invoiceAmount: c.invoice.amount,
            invoiceCurrencyCode: c.invoice.currency
          }
        })
      }
      return result
    } catch (error) {
      if (error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.hasOwnProperty('code')) {
        throw new BusinessException(error.response.data.code, error.response.data.message)
      } else {
        throw new TechnicalException(error)
      }
    }
  },
  async createBuyerClaim (buyerClaim) {
    try {
      let params = {
        version: '3'
      }
      let response = await http.Claim.post(`coverage/invoices/claims`, buyerClaim, { params })
      return response.data
    } catch (error) {
      if (error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.hasOwnProperty('code')) {
        throw new BusinessException(error.response.data.code, error.response.data.message)
      } else {
        throw new TechnicalException(error)
      }
    }
  },
  async updateBuyerClaim (buyerClaim) {
    try {
      let params = {
        version: '3'
      }
      let response = await http.Claim.patch(`coverage/invoices/claims/${buyerClaim.id}`, buyerClaim, { params })
      return response.data
    } catch (error) {
      if (error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.hasOwnProperty('code')) {
        throw new BusinessException(error.response.data.code, error.response.data.message)
      } else {
        throw new TechnicalException(error)
      }
    }
  },
  async getBuyerClaims (page, pageSize, buyerCompanyName) {
    try {
      let params = {
        version: '3',
        page: !!page ? page : 0,
        pageSize: !!pageSize ? pageSize : 100,
        buyerCompanyName: buyerCompanyName
      }
      let response = await http.Claim.get(`coverage/invoices/claims`, { params })
      return {
        items: response.data,
        totalCount: Number(response.headers['x-totalcount'])
      }
    } catch (error) {
      if (error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.hasOwnProperty('code')) {
        throw new BusinessException(error.response.data.code, error.response.data.message)
      } else {
        throw new TechnicalException(error)
      }
    }
  },
  async getBuyerClaimsExtendedInfo (ids) {
    try {
      let params = {
        version: '3'
      }
      let response = await http.Claim.post(`coverage/invoices/claims/extended`, ids, { params })
      return response.data
    } catch (error) {
      if (error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.hasOwnProperty('code')) {
        throw new BusinessException(error.response.data.code, error.response.data.message)
      } else {
        throw new TechnicalException(error)
      }
    }
  },
  async getBuyerClaimById (id) {
    try {
      let params = {
        version: '3'
      }
      let response = await http.Claim.get(`coverage/invoices/claims/${id}`, { params })
      return response.data
    } catch (error) {
      if (error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.hasOwnProperty('code')) {
        throw new BusinessException(error.response.data.code, error.response.data.message)
      } else {
        throw new TechnicalException(error)
      }
    }
  },
  async cancelBuyerClaim (id) {
    try {
      let params = {
        version: '3'
      }
      let response = await http.Claim.post(`coverage/invoices/claims/${id}/cancel`, null, { params })
      return response.status === 200
    } catch (error) {
      if (error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.hasOwnProperty('code')) {
        throw new BusinessException(error.response.data.code, error.response.data.message)
      } else {
        throw new TechnicalException(error)
      }
    }
  },
  async validateBuyerClaim (id) {
    try {
      let params = {
        version: '3'
      }
      let response = await http.Claim.post(`coverage/invoices/claims/${id}/validate`, null, { params })
      return response.status === 200
    } catch (error) {
      if (error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.hasOwnProperty('code')) {
        throw new BusinessException(error.response.data.code, error.response.data.message)
      } else {
        throw new TechnicalException(error)
      }
    }
  }
}
